module.exports = __webpack_public_path__ + "assets/images/coin.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin.png
// module id = 247
// module chunks = 1